import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {SearchSpan,AddNewButtonLayout, TableCheckBox} from '../../common/Global/globalStyles.style';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import UserManagementTopMenu from './topmenu';
import TableDropDown from '../../common/DropdownMenus/TableDropdown';
import FilterDropDown from '../../common/DropdownMenus/FilterDropdown';
import AlertDialog from '../../common/AlertDialog';
import Pagination from '../../common/Global/pagination';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import {getLocalStorageVariables,isEmptyVariable,sortTable,truncateString,
     isEmptyArray,getThemeSettingsVariables,handleTokenExpiry,
     ifEmptyReturnEmptyStr} from '../../common/Global/commonFunctions';
import { connect } from "react-redux";
import { setUserRoleFilters } from '../../../reducers/authSlice';
import SelectDepartmentDialog from '../../pages/Tasks/selectDepartment';
import { Modal } from 'react-bootstrap';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
const sortDashboardRoleName = "dr.dashboardRoleName";
const dashboardRoleDescription = "dr.dashboardRoleDescription";
const sortDashboardRoleUserCount = "dashboardRoleUserCount";
const departmentFilterDropdownDefaultValue = "All";

class ListDashboardRoles extends Component {
    constructor(props) {
        super(props);
        const item = props.location.state;
        this.state = {
            componentDidMountFlag:false,
            apiSearchKey:"",
            searchkey:"",
            currentPageNo: 1,
            showLoader:false,
            resultSize:Constants.RESULT_SIZE,
            totalCount:0,
            statusPlaceholder:"Active",
            resultSizePlaceholder:Constants.RESULT_SIZE,
            sort:"",
            sortDir:"",

            datalist:[],
            showAlertDialog:false,
            operationType:"",
            alertDialogMessage:"",
            showBtnLoader:false,

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            status:"Active",
            statusArr:[
                {
                    label:"Active",
                    isSelected:true
                },
                {
                    label:"Inactive",
                    isSelected:false
                }
            ],
            resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
            
            dashboardRoleId:"",
            departmentList:[],
			// selectedDepartmentName: departmentDropdownDefaultValue,
			selectedDepartmentId: "",
            selectedFilterDepartmentId:""
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getUserRolesList();
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onSearchIconClick = () => {
        this.setState({
            currentPageNo:1
        },()=>{
            this.getUserRolesList();
        })
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.setState({
                currentPageNo:1
            },()=>{
                this.getUserRolesList();
            })
        }
    }

    handleAlertDialogClose = () =>{
        this.setState({
            showAlertDialog:false,
            alertDialogMessage:""
        });
    }

    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    onTableDropDownItemClick = (item, dropdownItem) => {
        if(item.label === "Delete"){
            this.setState({
                operationType:item.label,
                dashboardRoleId:dropdownItem.dashboardRoleId,
                selectedDepartmentId:dropdownItem.departmentId,
                showAlertDialog:true,
                alertDialogMessage:"Are you sure you want to delete user role "+dropdownItem.dashboardRoleName+"?"
            })
        }else if(item.label === "Reactivate"){
            this.setState({
                operationType:item.label,
                dashboardRoleId:dropdownItem.dashboardRoleId,
                showAlertDialog:true,
                alertDialogMessage:"Are you sure you want to reactivate user role "+dropdownItem.dashboardRoleName+"?"
            })
        }else if(item.label === "Edit"){
            this.props.history.push(Constants.URL_EDIT_DASHBOARD_ROLE+"/"+dropdownItem.dashboardRoleId, {
                dashboardItem:dropdownItem
            });
        }
    }

    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn,this.state.sort,this.state.sortDir);

        this.setState({
            sort:sortObj.sortTemp,
            sortDir:sortObj.sortDirTemp,
        },()=>{
            this.getUserRolesList();
        })
    }

    handleDetailsDialogShow = (item) =>{
        this.setState({
            showDetailsDialog:true,
            selectedDashboardRoleId:item.dashboardRoleId,
            dashboardClientId:item.dashboardClientId,
            departmentId:item.departmentId
        },()=>{
            this.getDashboardDetails();
        });
    }

    handleDetailsDialogClose = () =>{
        this.setState({
            showDetailsDialog:false,
            selectedDashboardRoleId:""
        });
    }
    
    statusDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.statusArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            statusArr:tempArr,
            status:item.label,
            statusPlaceholder:placeholder
        }, () => {
            this.getUserRolesList();
        })
    }

    deptFilterDropdownClick = (item, selectedIndex) => {
		let placeholder = "";
		let id = "";
		let filterDeptArr = this.state.filterDeptArr;

		for (const [i, value] of filterDeptArr.entries()) {
			if (i === selectedIndex) {
				filterDeptArr[i].isSelected = true;
				placeholder = value.name;
				id = value.departmentId;
			} else {
				filterDeptArr[i].isSelected = false;
			}
		}

		this.setState(
			{
				currentPageNo: 1,
				selectedFilterDepartmentName: placeholder,
				selectedFilterDepartmentId: id,
			},
			() => {
				this.getAssignmentList();
			}
		);
	};

    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        },() => {
            this.getUserRolesList();
        })
    }

    addDashboardRole = () => {
        if(this.state.departmentList.length > 1){
            this.setState({
                showSelectDeptDialog:true,
                departmentList:this.state.departmentList
            })
        }else{
            this.props.history.push(Constants.URL_ADD_DASHBOARD_ROLE, {
                departmentArr:this.state.departmentList[0]
            })
        }
    }

    handleSelectDeptDialogClose = () => {
        this.setState({
            showSelectDeptDialog:false,
        })
    }

    handleSelectDeptDialogSaveClose = (selectedDepartmentId) => {
        let departmentArr = this.state.departmentList.find(item => item.departmentId == selectedDepartmentId)
        this.props.history.push(Constants.URL_ADD_DASHBOARD_ROLE, {
            departmentArr:departmentArr
        })
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }
    
    getUserRolesList = () => {
        this.setState({
            showLoader:true,
        });
        Promise.all([
            fetch(Constants.DashboardsRoles,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:this.state.currentPageNo,
                    search:this.state.searchkey,
                    resultsize:this.state.resultSize,
                    status:this.state.status === "Active" ? "All" : this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir,
                    departmentId:this.state.selectedFilterDepartmentId
                })
            }),
            fetch(Constants.GetUserMenu,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                })
            })
        ])
        .then(([masterRes,menuRes]) => { 
            return Promise.all([masterRes.json(),menuRes.json()]) 
        })
        .then(([masterRes,menuRes]) => {
            let deptTemp = [];
            let dashboardRole = [];
            let totalCount = 0;
            let menus = {};

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                dashboardRole = masterRes.data.dashboardRoleList;
                totalCount = masterRes.data.totalCount;
            }else{
            }

            if(handleTokenExpiry(menuRes.responseCode)) return;
            else if(menuRes.responseCode === Constants.CODE_SUCCESS){
                deptTemp = menuRes.data.departments.sort((a, b) => a.name.localeCompare(b.name));
                menus = menuRes.data.menus;
            }else{
                deptTemp = {};
            }

            //Filter Dept array
            let filterDeptArr = [];
            let selectedFilterDepartmentId = "";
            let selectedFilterDepartmentName = "All";
            if (!isEmptyArray(deptTemp) && deptTemp.length === 1) {
            } else {
                let obj = {
                    departmentId: "",
                    name: departmentFilterDropdownDefaultValue,
                    isSelected: true,
                };
                filterDeptArr = [...deptTemp];
                filterDeptArr.splice(0, 0, obj);
            }

            this.setState({
                showLoader:false,
                componentDidMountFlag:true,
                datalist:dashboardRole,
                totalCount:totalCount,
                // apiSearchKey:this.state.searchkey,
                departmentList:deptTemp,
                filterDeptArr: filterDeptArr,
				selectedFilterDepartmentId: selectedFilterDepartmentId,
				selectedFilterDepartmentName: selectedFilterDepartmentName,
                menus:menus
            })
        });
    }

    onChangePage = (page) => {
        // update state with new page of items
        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });
            fetch(Constants.DashboardsRoles,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:page,
                    search:this.state.searchkey,
                    resultsize:this.state.resultSize,
                    status:this.state.status == "Active" ? "All" : this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir,
                    departmentId:this.state.selectedFilterDepartmentId
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showLoader:false,
                        datalist:data.data.dashboardRoleList,
                        totalCount:data.data.totalCount,
                        apiSearchKey:this.state.searchkey,
                        currentPageNo:page,
                    },() => {
                        this.saveFilterValues();
                    })
                }else{
                    this.setState({
                        datalist:[],
                        showLoader:false,
                        apiSearchKey:this.state.searchkey,
                    })
                }
            });
        }
    }

    deleteActivateUserRole = () => {
        let url = "";

        if(this.state.operationType === "Delete"){
            url = Constants.DashboardRoleDelete;
        }
        // else if(this.state.operationType === "Reactivate"){
        //     url = Constants.ActivateRole;
        // }

        this.setState({
            showBtnLoader:true,
        });

        fetch(url,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                departmentId:this.state.selectedDepartmentId,
                dashboardRoleId:this.state.dashboardRoleId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    dashboardRoleId:"",
                    operationType:"",
                    alertDialogMessage:"",
                    showAlertDialog:false,
                    showBtnLoader:false
                },() => {
                    this.getUserRolesList();
                });
            }else{
                this.setState({
                    showBtnLoader:false,
                    dashboardRoleId:"",
                    operationType:"",
                    alertDialogMessage:"",
                    showAlertDialog:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    getDashboardDetails = () => {
        Promise.all([
            fetch(Constants.GetDashboardRoleCreateMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    departmentId:this.state?.departmentId ??""
                })
            }),
            fetch(Constants.DashboardsRoles+"/"+this.state.selectedDashboardRoleId,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                })
            })
        ])
        .then(([masterRes,dashboardDetailRes]) => { 
            return Promise.all([masterRes.json(), dashboardDetailRes.json()]) 
        })
        .then(([masterRes, dashboardDetailRes]) => {
            let clientDashboardList = {}
            let matrix = [];
            let dashboardRoleName = "";
            let dashboardRoleDescription = "";

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                clientDashboardList = masterRes.data.clientDashboardList;                
            }else{
            }

             if(handleTokenExpiry(dashboardDetailRes.responseCode)) return;
            else if(dashboardDetailRes.responseCode === Constants.CODE_SUCCESS){
                dashboardRoleName = dashboardDetailRes.data.dashboardRoleName;
                dashboardRoleDescription = dashboardDetailRes.data.dashboardRoleDescription;
                matrix = dashboardDetailRes.data.matrix;
                
            }else{
                
            }
            const matrixIds = new Set(
                matrix.map(item => item.dashboardClientId)
            );
            const updatedClientDashboardList = clientDashboardList.map(item => ({
                ...item,
                isChecked: matrixIds.has(item.dashboardClientId)
            }));
            this.setState({
                selectedDashboardRoleName:dashboardRoleName,
                selectedDashboardRoleDesc:dashboardRoleDescription,
                matrix:matrix,
                clientDashboardList:updatedClientDashboardList,
            })

        });
    }

    render() {
        const actionArr = [
            {
                icon:"edit",
                label:"Edit"
            },
            {
                icon:"delete",
                label:"Delete"
            },
        ]

        const actionArrReactivate = [
            {
                icon:"check_circle",
                label:"Reactivate"
            },
        ]

        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }
                                <UserManagementTopMenu 
                                    themeSettings = {themeSettings}
                                    showDashboardTab={true}
                                />

                                {
                                    // Need to check component did mount flag, other wise until api is called,
                                    // it shows no items found layout.
                                    this.state.componentDidMountFlag &&
                                    <div className="body-wrapper">
                                        <div className="search-addnew-bg">
                                            <div className="search-addnew">
                                                <div className="search-filter-layout">
                                                    <FilterDropDown
                                                        placeholder={this.state.resultSizePlaceholder}
                                                        dropdownArr={this.state.resultSizeArr}
                                                        onDropDownItemClick={this.resultSizeDropdownClick}
                                                        themeSettings = {themeSettings}
                                                        mleft={0}
                                                    />
                                                    <div className="search-col m-l-10">
                                                        <input 
                                                            name="searchkey" 
                                                            type="text"
                                                            onChange={this.handleChange}
                                                            placeholder="Search" 
                                                            onKeyPress={this.onEnterBtnPress}
                                                            value={this.state.searchkey} />
                                                        <SearchSpan 
                                                            className="material-icons"
                                                            themeSettings = {themeSettings}
                                                            onClick = {this.onSearchIconClick}>search</SearchSpan>
                                                    </div>
                                                    <FilterDropDown
                                                        placeholder={this.state.statusPlaceholder}
                                                        dropdownArr={this.state.statusArr}
                                                        onDropDownItemClick={this.statusDropdownClick}
                                                        themeSettings = {themeSettings}
                                                    />
                                                    {this.state.filterDeptArr.length > 0 && (
														<FilterDropDown
															placeholder={this.state.selectedFilterDepartmentName}
															dropdownArr={this.state.filterDeptArr}
															onDropDownItemClick={this.deptFilterDropdownClick}
															name={"name"}
															themeSettings={themeSettings}
															dropdownWidth={"120px"}
														/>
													)}
                                                </div>
                                                {this.state.menus[Constants.SCREEN_DASHBOARD_ROLES] === "ALL" &&
                                                    <AddNewButtonLayout
                                                        themeSettings = {themeSettings}
                                                    >
                                                        <a onClick={this.addDashboardRole} href="javascript:void(0)" data-toggle="modal" data-target="#addnewModal">
                                                            <span className="material-icons">add_circle</span>
                                                            <p>Add New</p>
                                                        </a>
                                                    </AddNewButtonLayout>
                                                }
                                            </div>
                                        </div>
                                        {
                                            !isEmptyArray(this.state.datalist) && 
                                            <div className="common-tab-bg">
                                                <div className="common-table" style={{width:"100%"}}>
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                            <th className="text-center" width={"5%"}>No.</th>
                                                            <th className="c-pointer" width={"20%"} onClick={this.sortTableLocal.bind(this,sortDashboardRoleName)}>
                                                                <div className="sort-header">Dashboard Role
                                                                <span className={(this.state.sort === sortDashboardRoleName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th className="c-pointer" onClick={this.sortTableLocal.bind(this,dashboardRoleDescription)}>
                                                                <div className="sort-header">Description
                                                                <span className={(this.state.sort === dashboardRoleDescription)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th width={"17%"} className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDashboardRoleUserCount)}>
                                                                <div className="sort-header">Dashboard Role Users
                                                                <span className={(this.state.sort === sortDashboardRoleUserCount)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            {this.state.menus[Constants.SCREEN_DASHBOARD_ROLES] === "ALL" &&
                                                                <th className="text-center" width={"5%"}></th>
                                                            }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            !isEmptyArray(this.state.datalist) && 
                                                            this.state.datalist.map((item,idx) => {
                                                                return <tr onClick={this.handleDetailsDialogShow.bind(this,item)}>
                                                                    <td className="text-center">{((this.state.currentPageNo - 1) * this.state.resultSize) + (++idx)}</td>
                                                                    <td>{item.dashboardRoleName}</td>
                                                                    <td>{truncateString(item.dashboardRoleDescription,120)}</td>
                                                                    <td>{item.dashboardRoleUserCount}</td>
                                                                    {this.state.menus[Constants.SCREEN_DASHBOARD_ROLES] === "ALL" &&
                                                                        <td className="text-center">
                                                                            <TableDropDown 
                                                                                actionArr={actionArr}
                                                                                onDropDownItemClick={this.onTableDropDownItemClick}
                                                                                dropDownId={item}
                                                                                themeSettings={themeSettings}
                                                                            />
                                                                        </td>
                                                                    }
                                                                </tr>
                                                            })
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                        {
                                            this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) &&
                                            <div class="no-items-layout">
                                                <div class="no-items-card">
                                                    <h6>
                                                    {
                                                        isEmptyVariable(this.state.apiSearchKey)?
                                                        Constants.NO_RECORDS_WARNING
                                                        :
                                                        Constants.EMPTY_SEARCH_WARNING
                                                    }
                                                    </h6>
                                                </div>
                                            </div>
                                        }
                                        <div className="pagination-layout">
                                            <div className="row custom-row">
                                                <div className="col-md-9 custom-col">
                                                {
                                                    (this.state.totalCount > this.state.datalist.length) && 
                                                    <Pagination 
                                                        totalLength ={this.state.totalCount} 
                                                        items={this.state.datalist} 
                                                        onChangePage={this.onChangePage} 
                                                        pageSize={this.state.resultSize}
                                                        currentPageNo = {this.state.currentPageNo}
                                                        initialPage={this.state.currentPageNo}
                                                        themeSettings = {themeSettings}
                                                    />
                                                }
                                                </div>
                                                <div className="col-md-3 custom-col">
                                                    <p>{"Total Records: "+this.state.totalCount}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialog}
                            handleAlertDialogClose={this.handleAlertDialogClose}
                            type={
                                (this.state.operationType === "Delete")
                                ?
                                Constants.ALERT_TYPE_WARNING
                                :
                                Constants.ALERT_TYPE_INFO
                            }
                            alertDialogHeading={
                                (this.state.operationType === "Delete")
                                ?
                                "Delete User Role"
                                :
                                "Activate User Role"
                            }
                            alertDialogMessage={this.state.alertDialogMessage}
                            proceedBtnClick={this.deleteActivateUserRole}
                            proceedBtnLabel={
                                (this.state.operationType === "Delete")
                                ?
                                "Delete"
                                :
                                "Reactivate"
                            }
                            showLoader={this.state.showBtnLoader}
                            themeSettings = {themeSettings}
                        />

                         <AlertDialog 
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type= {Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                            themeSettings = {themeSettings}
                        />

                        <SelectDepartmentDialog
                            showDeptDialog={this.state.showSelectDeptDialog}
                            handleSelectDeptDialogClose={this.handleSelectDeptDialogClose}
                            handleSelectDeptDialogSaveClose={this.handleSelectDeptDialogSaveClose}
                            selectedDeptId={this.state.selectedDepartmentId}
                            departmentArr={this.state.departmentList}
                            themeSettings = {themeSettings}
                        />

                        <Modal className="user-role-dialog custom-dialog" show={this.state.showDetailsDialog} backdrop="static">
                            <Modal.Header>
                                <h5>{this.state.selectedDashboardRoleName}</h5>
                                <button 
                                    onClick={this.handleDetailsDialogClose}
                                    type="button" data-dismiss="modal">
                                    <span class="material-icons">close</span>
                                </button>
                            </Modal.Header>
                            <hr />
                            <Modal.Body>
                                <div className="details-table-layout">
                                    <table className="m-b-10">
                                        <tbody>
                                            <tr>
                                                <td width={"12%"}>Role Name</td>
                                                <td width={"4%"}>:</td>
                                                <td width={"84%"}>{this.state.selectedDashboardRoleName}</td>
                                            </tr>
                                            <tr>
                                                <td width={"12%"}>Description</td>
                                                <td width={"4%"}>:</td>
                                                <td width={"84%"}>{ifEmptyReturnEmptyStr(this.state.selectedDashboardRoleDesc,"-")}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <h6>Dashboard Role Matrix</h6>
                                <div className="common-tab-bg">
                                    <div className="common-table" style={{width:"100%"}}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th width={"5%"}></th>
                                                    <th>Name</th>
                                                    <th>Description</th>
                                                    <th>Base template</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    !isEmptyArray(this.state.clientDashboardList) && 
                                                    this.state.clientDashboardList.map((item,idx) => {
                                                        return <tr>
                                                            <td>
                                                                <TableCheckBox onClick={this.handleStopPropagation} themeSettings={themeSettings} >
                                                                    <input 
                                                                        type="checkbox"
                                                                        name={idx}
                                                                        id={item.dashboardClientId}
                                                                        checked={item.isChecked?true:false}
                                                                    />
                                                                    <label for={item.dashboardClientId} 
                                                                    style={{marginLeft:2}}></label>
                                                                </TableCheckBox>
                                                            </td>
                                                            <td>{item.dashboardClientName}</td>
                                                            <td>{item.dashboardClientDescription}</td>
                                                            <td>{item.templateName}</td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </section>
                </main>
            </Router>
        );
    }
}

export default connect(null, { setUserRoleFilters })(ListDashboardRoles);